export class ValidationUtils {
  public static excludeArrayIndexing(path: string): string {
    var result: string = path;

    while (result.indexOf('[') > -1) {
      var rightBracketIndex = result.indexOf(']');
      var leftBracketIndex = result.substr(0, rightBracketIndex).lastIndexOf('[');
      var leftPart = result.substr(0, leftBracketIndex);
      var rightPart = result.substring(rightBracketIndex + 1);
      result = leftPart + rightPart;
    }

    return result;
  }
}
